// extracted by mini-css-extract-plugin
var _1 = "useMagneticWallSheetContext-module__highlight--zVLwu";
var _2 = "useMagneticWallSheetContext-module__image--XpZ8x";
export { _1 as "highlight", _2 as "image" }
